module.exports = __webpack_public_path__ + "static/media/20ECE21.c7453842.jpg";